import * as React from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import PasswordIcon from '@mui/icons-material/Password';
import TextsmsIcon from '@mui/icons-material/Textsms';
import EmailIcon from '@mui/icons-material/Email';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { codeLogin, useAuthDispatch } from '../context'
import UnPwLoginForm from './forms/UsernamePasswordLoginForm';
import CodeLoginForm from './forms/CodeLoginForm';
import Request from './AxiosInstance';
import { toast } from 'react-toastify';
import {useNavigate} from 'react-router-dom';
import {useState} from 'react';


const LoginComponent = () => {

	function TabPanel(props) {
		const { children, value, index, ...other } = props;

		return (
			<div
				role="tabpanel"
				hidden={value !== index}
				id={index}
				{...other}
			>
				{value === index && (
					<Box sx={{ p: 3 }}>
						{children}
					</Box>
				)}
			</div>
		);
	}
	TabPanel.propTypes = {
		children: PropTypes.node,
		index: PropTypes.number.isRequired,
		value: PropTypes.number.isRequired,
	};

	const [tabValue, setTabValue] = useState(0);
	const [receiverType, setReceiverType] = useState('text');

	const dispatch = useAuthDispatch();
	const navigate = useNavigate();

	const handleTabChange = (event, newValue) => {
		if (newValue !== null) {
			setTabValue(newValue);
			setReceiverType(newValue === 1 ? 'text' : 'email');
		}
	};

	const handleGetCode = async (payload) => {
		try {
			await Request.post('/auth/getcode', payload);
		} catch (e) {
			toast.error(e.message);
		}
	}

	const handleCodeSubmit = async (payload) => {
		try {
			const response = await codeLogin(dispatch, payload)
			if (response.status === 'Success') {
				navigate('/pcd');
			} else if (response.status === 'MultipleAccountsExist') {
				return response.accountList;
			}
		} catch (e) {
			console.error(e)
		}
	}

	return (
		<Box
			sx={{
				mt: 3,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
			}}
		>
			<ToggleButtonGroup
				color="primary"
				sx={{ mt: 2 }}
				value={tabValue}
				exclusive
				onChange={handleTabChange}
			>
				<ToggleButton value={0}>
					<Tooltip title={"Username & Password"}>
						<PasswordIcon/>
					</Tooltip>
				</ToggleButton>
				<ToggleButton value={1}>
					<Tooltip title={"Text Message"}>
						<TextsmsIcon/>
					</Tooltip>
				</ToggleButton>
				<ToggleButton value={2}>
					<Tooltip title={"Email"} >
						<EmailIcon/>
					</Tooltip>
				</ToggleButton>
			</ToggleButtonGroup>
			<TabPanel value={tabValue} index={0}>
				<UnPwLoginForm />
			</TabPanel>
			<TabPanel value={tabValue} index={1}>
				<CodeLoginForm
					method={receiverType}
					handleGetCode={handleGetCode}
					handleCodeSubmit={handleCodeSubmit}
				/>
			</TabPanel>
			<TabPanel value={tabValue} index={2}>
				<CodeLoginForm
					method={receiverType}
					handleGetCode={handleGetCode}
					handleCodeSubmit={handleCodeSubmit}
				/>
			</TabPanel>
			<Grid container sx={{ justifyContent: "end" }}>
				<Grid item>
					<Link href="r" variant="body2">
						{"Don't have an account? Sign Up"}
					</Link>
				</Grid>
			</Grid>
		</Box>
	);
}

export default LoginComponent;